// extracted by mini-css-extract-plugin
module.exports = {"features":"Features_features__3_ZdC","header":"Features_header__1noXX","grid":"Features_grid__37Wg8","card":"Features_card__ZIAIu","icon":"Features_icon__2AjOf"};